import React from "react"
import PropTypes from "prop-types"
import { getMonthLongNameByNumber } from "../../../utils/date.utils"

const MonthNavigator = ({
  month,
  year,
  onPrev,
  onNext,
  disablePrev,
  disableNext,
}) => {
  if (!month || !year) return null

  return (
    <div className="month-navigator">
      <div className="month-navigator-label">
        <i className="pi pi-calendar"></i>

        <span>
          {getMonthLongNameByNumber(month)}/{year.toString().slice(-2)}
        </span>
      </div>

      <div className="month-navigator-controls">
        <button onClick={onPrev} disabled={disablePrev}>
          <i className="pi pi-chevron-left"></i>
        </button>

        <button onClick={onNext} disabled={disableNext}>
          <i className="pi pi-chevron-right"></i>
        </button>
      </div>
    </div>
  )
}

export default MonthNavigator

MonthNavigator.propTypes = {
  month: PropTypes.number,
  year: PropTypes.number,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  disablePrev: PropTypes.bool,
  disableNext: PropTypes.bool,
}
